// @flow

// no guarantee that a value is unique, the only guarantee is that the keys are
// unique (no enum support in flow)
const errorCodes = Object.freeze({
  USER_MATCH_NOT_FOUND: 100
});

type TClientErrorCode = $Values<typeof errorCodes>;

export type ClientErrorOptions = {
  /**
   * The http status code, set as 400 by default
   */
  statusCode?: number,
  /**
   * The error code, internal to the application
   */
  errorCode: TClientErrorCode,
  /**
   * Additional metadata attached to the error
   */
  meta?: any
};

// from https://javascript.info/custom-errors
export default class ClientError extends Error {
  statusCode: number;
  errorCode: TClientErrorCode;
  meta: any;

  static errorCodes = errorCodes;

  constructor(message: string, options: ClientErrorOptions) {
    super(message);
    this.name = ClientError.name;
    this.statusCode = options.statusCode || 400;
    this.errorCode = options.errorCode;
    this.meta = options.meta;
  }
}



// WEBPACK FOOTER //
// ./src/utils/errors/ClientError.js